<template>
	<img class="type-image" :src="src" :alt="alt" :style="_style">
</template>

<script>
	export default {
		name: 'type-image',
		props: {
			src: {
				type: String,
				default: ''
			},
			alt: {
				type: String,
				default: ''
			},
			mode: {
				type: String,
				default: 'auto',
				// auto			不设置宽高
				// fixed		设置固定宽高
				// widthFix		缩放模式，宽度不变，高度自动变化，保持原图宽高比不变	
				// heightFix	缩放模式，高度不变，宽度自动变化，保持原图宽高比不变
				validator: value => ['auto', 'fixed', 'widthFix', 'heightFix'].includes(value)
			},
			width: {
				type: String,
				default: ''
			},
			height: {
				type: String,
				default: ''
			}
		},
		computed: {
			_style() {
				if (this.mode === 'auto') {
					return '';
				}
				if (this.mode === 'fixed') {
					return `width: ${this.width || '100%'};height: ${this.height || '100%'};`;
				}
				if (this.mode === 'widthFix') {
					return `width: ${this.width || '100%'};`;
				}
				if (this.mode === 'heightFix') {
					return `height: ${this.height || '100%'};`;
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.type-image{
		transition: transform 300ms ease-in;
	}
</style>
